<template>
  <auto-suggest
    v-model="suggestValue"
    :input-props="{id:'autosuggest__input', class: 'form-control', placeholder, disabled}"
    :suggestions="filteredValues"
    :get-suggestion-value="suggestionValue"
    @selected="onSelected"
  >
    <div slot-scope="{suggestion}">
      {{formatValue(suggestion.item)}}
    </div>
  </auto-suggest>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'
// Note the use of the props: value: This is necessary to facilitate the interaction of
// the parents v-model which sets the value in the child, and is set by the emit of
// the 'input' event.
export default {
  props: {
    value: {
      type: String
    },
    data: {
      type: Array,
      required: true
    },
    keyProperty: {
      type: String,
      required: true
    },
    valueProperty: {
      type: String|Function,
      required: true
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String
    }
  },
  setup(props, context) {
    const suggestValue = ref('')
    watch(
      () => props.value,
      (k, old) => {
        suggestValue.value = inputValue(k)
      }
    )
    watch(
      () => props.data,
      (k, old) => {
        suggestValue.value = inputValue(props.value)
      }
    )
    function inputValue(key) {
      if (key == undefined) {
        return ''
      }
      let found = props.data.find((item) => item[props.keyProperty] == key)
      if (found) {
        return formatValue(found)
      }
      return ''
    }
    function formatValue(item) {
      if (typeof props.valueProperty === 'function') {
        return props.valueProperty(item)
      }
      return item[props.valueProperty]
    }
    function suggestionValue(suggestion) {
      return formatValue(suggestion.item)
    }
    const filteredValues = computed(() => {
      return [{
        data: props.data.filter(item => {
          if (!suggestValue.value) return false
          let v = formatValue(item)
          if (!v) return false
          return v.toLowerCase().includes(suggestValue.value.toLowerCase())
        })
      }]
    })
    function onSelected(suggestion, index) {
      context.emit('input', suggestion.item[props.keyProperty])
    }
    return {
      suggestValue,
      formatValue,
      filteredValues,
      suggestionValue,
      onSelected
    }
  }
}
</script>
<style lang="scss">
</style>